import React from "react";
import PolicyPageLayout from "../components/PolicyPageLayout";

const sections = [
  {
    title: "1. Information We Collect",
    body: [
      "We may collect your name, email address, phone number, delivery address, order history, and messages you send through our website.",
      "We also collect limited technical data such as cookies and analytics information to help us improve the shopping experience.",
    ],
    items: [
      "Customer name and contact details",
      "Delivery address and order information",
      "Payment status and order history",
      "Usage and device data where cookies are enabled",
    ],
  },
  {
    title: "2. How We Use Your Information",
    body: [
      "We use your information to process orders, deliver products, send order updates, respond to enquiries, and improve our services.",
      "We may also use your details to send service messages related to your account or recent purchases.",
    ],
    items: [
      "Order processing and delivery",
      "Customer support and communication",
      "Fraud prevention and service improvement",
      "Account and order notifications",
    ],
  },
  {
    title: "3. Google Sign-In",
    body: [
      "If you choose to sign in with Google, we receive the basic account information Google provides, such as your name, email address, and profile identifier, to create and secure your Zea Mays Foods account.",
      "We do not use Google account information for unrelated advertising or sell it to third parties.",
    ],
  },
  {
    title: "4. Sharing of Information",
    body: [
      "We do not sell or rent your personal information.",
      "We may share necessary information with trusted service providers such as payment processors, delivery partners, and infrastructure providers who help us operate the business.",
    ],
  },
  {
    title: "5. Data Security and Your Rights",
    body: [
      "We use reasonable administrative and technical safeguards to protect your data, but no online system is perfectly secure.",
      "You may request access, correction, or deletion of your personal information where applicable.",
    ],
    items: [
      "Access your data",
      "Request correction",
      "Request deletion where allowed",
      "Opt out of non-essential messages",
    ],
  },
];

const PrivacyPolicyPage = () => {
  return (
    <PolicyPageLayout
      title="Privacy Policy"
      intro="This Privacy Policy explains how Zea Mays Foods collects, uses, and protects your personal information when you browse, order, or contact us through the website."
      sections={sections}
      contactEmail="zeamaysfood@gmail.com"
      contactPhone="+2347037038448"
      lastUpdated="July 14, 2026"
    />
  );
};

export default PrivacyPolicyPage;
